import React from "react";
import ReactDOM from "react-dom";

window.React = React;
window.ReactDOM = ReactDOM;

export { StyledTolkienCalendars } from "./examples/TolkienCalendars";
export { StyledSimulations } from "./examples/simulation/TolkienCalendars";

export * from "./lib";
